import { render, staticRenderFns } from "./CarbonCapture.vue?vue&type=template&id=188439b6&scoped=true&"
import script from "./CarbonCapture.vue?vue&type=script&lang=js&"
export * from "./CarbonCapture.vue?vue&type=script&lang=js&"
import style1 from "./CarbonCapture.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188439b6",
  null
  
)

export default component.exports